/**
 * @file: LeadActionRow.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The active-lead CTA row: the 预约到店 primary action plus, on desktop, the
 * inline 标记流失 / 取消商机 secondary actions.
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CalendarPlus } from 'lucide-react-native';
import { View } from 'react-native';
import { ActionButton } from './common/ActionButton';

export const LeadActionRow = ({
  isDesktop,
  onReserve,
  onLose,
  onCancel,
}: {
  isDesktop: boolean;
  onReserve: () => void;
  onLose: () => void;
  onCancel: () => void;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        flexDirection: 'row',
        gap: rpx(10),
        marginTop: rpx(2),
        marginBottom: rpx(2),
      }}
    >
      <ActionButton
        label="预约到店"
        tone="primary"
        icon={CalendarPlus}
        onPress={onReserve}
      />
      {isDesktop ? (
        <>
          <ActionButton label="标记流失" tone="secondary" onPress={onLose} />
          <ActionButton
            label="取消商机"
            tone="destructive"
            onPress={onCancel}
          />
        </>
      ) : null}
    </View>
  );
};
